import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const LoadData = createAction('[Bulk Operations: Search]: Load Data');

export const PanelStatusChanged = createAction('[Bulk Operations: Search]: Panel Status Changed');

export const GetProfiles = createAction('[Bulk Operations: Search]: Get Profiles');

export const GetProfilesSuccess = createAction(
  '[Bulk Operations: Search]: Get Profiles Success',
  props<{ res: any }>(),
);

export const GetProfilesFailed = createAction(
  '[Bulk Operations: Search]: Get Profiles Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const ConfigurationNameChanged = createAction(
  '[Bulk Operations: Search]: Configuration Name Changed',
  props<{ configurationName: string }>(),
);

export const ProfileModelChanged = createAction(
  '[Bulk Operations: Search]: Profile Model Changed',
  props<{ profileModel: string }>(),
);

export const IsActiveChanged = createAction('[Bulk Operations: Search]: Is Active Changed');

export const ClearBulkSearchOptions = createAction('[Bulk Operations: Search]: Clear Bulk Search Options');

export const OpenAddNewConfSidenav = createAction('[Bulk Operations: Search]: Open Add New Conf Sidenav');

export const ChangeBulkActiveStatus = createAction(
  '[Bulk Operations: Search]: Change Bulk Active Status',
  props<{ bulkConfiguration: any }>(),
);

export const OpenDeactivateConfigurationDialog = createAction(
  '[Bulk Operations: Search]: Open Deactivate Configuration Dialog',
  props<{ bulkConfiguration: any }>(),
);

export const ActivationStatusConfiguration = createAction(
  '[Bulk Operations: Search]: Activation Status Configuration',
  props<{ bulkConfiguration: any }>(),
);

export const ActivationStatusConfigurationSuccess = createAction(
  '[Bulk Operations: Search]: Activation Status Configuration Success',
  props<{ res: any }>(),
);
export const ActivationStatusConfigurationFailed = createAction(
  '[Bulk Operations: Search]: Activation Status Configuration Failed',
  props<{ error: HttpErrorResponse }>(),
);
